<template>
  <div>
    <carousel
      :scrollPerPage="true"
      :perPageCustom="[[360, 1], [768, 3]]"
      :autoplay="true"
      :speed="1000"
      :autoplayTimeout="4000"
      :loop="true"
      :paginationEnabled="true"
      :navigationEnabled="true"
      :centerMode="true"
      :paginationActiveColor="colors.primary"
      paginationColor="#666666"
      :navigationNextLabel="navigationNext"
      :navigationPrevLabel="navigationPrev"
    >
      <slide
        v-bind:key="key"
        v-for="(value, key) of this.data"
        data-name="homeOccasioni"
      >
        <div class="slider pl-3 pr-3">
          <script type="application/ld+json">{{ JSON.stringify(value.microdata) }}</script>
          <div class="row">
            <div class="col-md-12">
              <div class="property-box shadow-none position-relative">
                <a
                  :href="'/immobile/' + value.slug"
                  class="property-img"
                >
                  <div
                    class="property-thumbnail"
                    :style="{ backgroundImage: 'url(' + value.thumbnail.sizes['512'] + ')' }"
                  >
                  </div>
                </a>

                <div class="property-img-overlay position-absolute d-flex justify-content-between px-2 py-2">
                  <div>
                    <span
                      v-if="value.type"
                      class="featured"
                    >{{ value.type }}</span>
                  </div>

                  <div>
                    <btn-favourite
                      a_class="btn btn-white bg-white py-1 px-2 text-primary"
                      :id="value.id"
                    ></btn-favourite>
                  </div>
                </div>

                <div class="detail">
                  <h3 class="title">
                    <a :href="'/immobile/' + value.slug">{{ truncateTitle(value.title) }}</a>
                  </h3>

                  <h5 class="location mt-1">
                    <a :href="'/immobile/' + value.slug">
                      <i class="fi flaticon-location"></i>
                      <span class="location-address-text">{{ value.address }}</span>
                    </a>
                  </h5>

                  <div class="price-ratings-box mt-3">
                    <span class="price">{{ value.price }}</span>
                  </div>

                  <div class="pt-1 pb-1">
                    <div class="item-flex-icone-caratteristiche d-flex flex-row">
                      <div
                        v-for="(detailItem, key3) of filterDetails(value.details)"
                        :key="key3"
                        class="item-flex-icone-caratteristiche-single"
                      >
                        <i :class="detailItem.icon"></i>

                        <div class="caratteristiche-text">
                          <div v-if="detailItem.type !== 'CHECKBOX'">{{ detailItem.value }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="footer clearfix">
                  <ul class="float-left">
                    <li class="d-md-none">
                      <a
                        @click="telefona(value)"
                        v-if="value.numeroDaChiamare"
                        :data-gtm-event="value.publisher.type == 'Azienda' ? 'click-telefono-azienda-step-1' : 'click-telefono-privato-step-1'"
                        :data-publisher="value.publisher.id"
                        :data-immobile="value.id"
                        :data-categoria="value.codice_categoria"
                        data-source="home-listing"
                        class="click-telefono"
                      >
                      <div class="svg-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="100%" height="100%"><path d="M14.2,16.261A12.133,12.133,0,0,1,7.747,9.793l3.4-3.406L4.887.122,1.716,3.292A5.9,5.9,0,0,0,0,7.5C0,14.748,9.252,24,16.5,24a5.889,5.889,0,0,0,4.207-1.716l3.171-3.171-6.265-6.265Zm5.092,4.609A3.9,3.9,0,0,1,16.5,22C10.267,22,2,13.733,2,7.5A3.907,3.907,0,0,1,3.13,4.707L4.887,2.95,8.324,6.387,5.389,9.322l.245.614a14.372,14.372,0,0,0,8.447,8.436l.606.231,2.926-2.927,3.437,3.437ZM14,2V0A10.011,10.011,0,0,1,24,10H22A8.009,8.009,0,0,0,14,2Zm0,4V4a6.006,6.006,0,0,1,6,6H18A4,4,0,0,0,14,6Z"/></svg>
                      </div>


                        <span class="card-action-text">CHIAMA</span>
                      </a>
                    </li>

                    <li>
                      <a @click.prevent="selectImmobile(value)">
                        <div class="svg-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%"><g id="_01_align_center" data-name="01 align center"><path d="M21,1H3A3,3,0,0,0,0,4V23H24V4A3,3,0,0,0,21,1ZM3,3H21a1,1,0,0,1,1,1v.667l-7.878,7.879a3.007,3.007,0,0,1-4.244,0L2,4.667V4A1,1,0,0,1,3,3ZM2,21V7.5L8.464,13.96a5.007,5.007,0,0,0,7.072,0L22,7.5V21Z"/></g></svg>
                        </div>

                        <div class="card-action-text">CONTATTA</div>
                      </a>
                    </li>

                    <li>
                      <a @click.prevent="onRichiediVisita(value)">
                        <div class="svg-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%"><g id="_01_align_center" data-name="01 align center"><path d="M21,2H18V0H16V2H8V0H6V2H3A3,3,0,0,0,0,5V24H24V5A3,3,0,0,0,21,2ZM2,5A1,1,0,0,1,3,4H21a1,1,0,0,1,1,1V8H2ZM2,22V10H22V22Z"/><rect x="15" y="13" width="2" height="2"/><rect x="11" y="13" width="2" height="2"/><rect x="7" y="13" width="2" height="2"/><rect x="15" y="17" width="2" height="2"/><rect x="11" y="17" width="2" height="2"/><rect x="7" y="17" width="2" height="2"/></g></svg>
                        </div>

                        <div class="card-action-text">VISITA</div>
                      </a>
                    </li>
                  </ul>

                  <div class="float-right">
                    <a :href="'/' + value.publisher.slug">
                      <img
                        :src="value.publisher.image ? value.publisher.image.sizes['256'] : value.tappo.sizes['256']"
                        class="logoag"
                        alt="logo.ag"
                      >
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import {
  Carousel,
  Slide
} from 'vue-carousel';
import Modal from '../../classes/modal.class';

export default {
  props: ['data', 'mutuo', 'sessionid', 'colors'],
  components: {
    Carousel,
    Slide
  },
  methods: {
    selectImmobile (item) {
      const modal = new Modal({
        name: 'home_carousel_richiedi_info_' + item.id,
        class: 'small-modal',
        padding: false,
        closeButton: true,
        component: 'contatta-inserzionista',
        callback: () => { this.$modal.hide('home_carousel_richiedi_info_' + item.id); },
        bind: {
          immobile: item,
          sessionId: this.sessionid
        }
      });
      this.$root.pushModal(modal);
    },
    onRichiediVisita (item) {
      const modal = new Modal({
        name: 'home_carousel_richiedi_visita_' + item.id,
        class: 'big-modal',
        padding: false,
        closeButton: true,
        component: 'richiedi-visita',
        callback: () => { this.$modal.hide('home_carousel_richiedi_visita_' + item.id); },
        bind: {
          immobile: item,
          sessionId: this.sessionid
        }
      });
      this.$root.pushModal(modal);
    },
    telefona (value) {
      this.$root.showModalTelefonoImmobile({
        immobile_id: value.id,
        publisher_id: value.publisher.id,
        codice_categoria: value.codice_categoria,
        event: value.publisher.type == 'Azienda' ? 'click-telefono-azienda-step-2' : 'click-telefono-privato-step-2',
        rif: value.rif,
        telefono: value.numeroDaChiamare,
        source: 'home-listing'
      });
    },
    filterDetails (details) {
      return _.slice(
        details
          .filter((x) => ['CHECKBOX', 'INTEGER'].includes(x.type)),
        0,
        4
      );
    },
    truncateTitle (title) {
      if (title.length > 55) {
        return title.substring(0, 55) + "...";
      } else {
        return title;
      }
    }
  },
  data () {
    return {
      selectedImmobile: null
    }
  },
  computed: {
    navigationNext: function () {
      return `<i class="fas fa-chevron-circle-right"></i>`
    },
    navigationPrev: function () {
      return `<i class="fas fa-chevron-circle-left"></i>`
    },
  }
}
</script>

<style
  lang="css"
  scoped
>
.slider {
  text-align: initial;
}

.property-box {
  height: 380px;
}

.property-thumbnail {
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.footer {
  height: 50px;
}

.detail {
  .title {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0;
    position: relative;
    height: 1rem;

    a {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: block;
      word-break: break-word;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.logoag {
  max-width: 150px;
}

.property-img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
}

.VueCarousel-navigation-button {
  top: 45% !important;
}
</style>